import { FC } from 'react';

export type BriefingFlowTagProps = {
  name: string;
  colour: string;
  height: number;
  topPosition: number;
  leftPosition: number;
};

export const BriefingFlowTag: FC<BriefingFlowTagProps> = ({
  name,
  colour,
  height,
  topPosition,
  leftPosition,
}) => (
  <div
    data-testid="briefing-flow-tag"
    className="fixed"
    style={{
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
    }}
  >
    <div
      className="origin-top-left absolute font-medium leading-0.5 px-2 py-1 rounded-bl text-white tracking-wider uppercase"
      style={{
        backgroundColor: colour,
        fontSize: '12px',
        transform: `rotate(-90deg) translateX(-${height}px)`,
      }}
    >
      {name}
    </div>
  </div>
);
